import { Component, OnInit } from '@angular/core';
import { ReverformService } from '../../core/services/reverform.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../../core/services/common.service';
import { validateNumericCharacters } from '../../common/validators/numeric-validator.directive';
import { validateLength } from '../../common/validators/length-validator.directive';

@Component({
    selector: 'app-revert-form',
    templateUrl: './revert-form.component.html',
    styleUrls: ['./revert-form.component.css']
})
export class RevertFormComponent implements OnInit {
    token: string;
    form: any;
    employee: any;
    params: any;
    detailsSubmitted = false;
    showForm = true;
    errorOccurred = false;

    constructor(
        private revertFormService: ReverformService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private commonService: CommonService
    ) {
        this.activatedRoute.params.subscribe(params => (this.token = params.token));
    }

    ngOnInit(): void {
        this.revertFormDetails();
        this.buildForm();


    }

    revertFormDetails(): void {
        this.revertFormService
            .findByInviteToken(this.token)
            .subscribe((data: any) => {
                this.employee = data;
                if (this.employee['verifying_authority_email']) {

                    this.form.patchValue(this.employee);

                    this.form.disable();

                    this.commonService.notifications.error('You have already filled the form');
                }
            });
    }

    buildForm() {
        this.form = this.fb.group({
            'is_employee_id_correct': ['', Validators.required],
            'is_date_of_joining_correct': ['', Validators.required],
            'is_date_of_relieving_correct': ['', Validators.required],
            'is_designation_correct': ['', Validators.required],
            'is_salary_correct': ['', Validators.required],
            'is_department_correct': ['', Validators.required],
            'exit_formalities_completed': ['', Validators.required],
            'employee_id_remarks': [''],
            'date_of_joining_remarks': [''],
            'date_of_relieving_remarks': [''],
            'salary_remarks': [''],
            'department_remarks': [''],
            'designation_remarks': [''],
            'rehire_eligibility': [''],
            'rehire_eligibility_remarks': [''],
            'reason_for_leaving': ['', Validators.required],
            'verifying_authority_name': ['', Validators.required],
            'verifying_authority_email': ['', Validators.email],
            'exit_formalities_remarks': [''],
            'remarks': [''],
            'documents_genuine': ['', Validators.required],
            'documents_genuine_remarks': [''],
            'verifying_authority_contact': ['', [validateNumericCharacters(''), validateLength('10')]],
            'hr_interest': ['', Validators.required]
        });
    }

    submitForm() {

        this.revertFormService.submitForm(this.token, this.form.value).subscribe(
            (success) => {
                this.commonService.notifications.success('Details Submitted Successfully');
                this.detailsSubmitted = true;
                this.showForm = false;
            },
            (error) => {
                this.errorOccurred = true;
                this.commonService.notifications.error('Some Error Occurred');

            });

    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/revert-form/revert-form.component.ts